import React from 'react'

import classes from './SidebarItems.module.css'

const sidebarItems = (props) => {
  return <ul className={classes.SidebarItems}>{props.children}</ul>
}

export default sidebarItems
